import { render } from "./blessing.vue?vue&type=template&id=65d55d0c&scoped=true"
import script from "./blessing.vue?vue&type=script&lang=js"
export * from "./blessing.vue?vue&type=script&lang=js"

import "./blessing.vue?vue&type=style&index=0&id=65d55d0c&scoped=true&lang=css"

import exportComponent from "E:\\waibao\\isa-community-toupin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d55d0c"]])

export default __exports__